import {OrderService, MovieService, RegionService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'

export default {

    mixins: [MetaData],

    data() {
        return {
            order: null,
            movie: {},
            cinema: {},
            session: undefined,
            stepType: "subscribe",
            stepNames: [
                {
                    step: 1,
                    text: 'Subscription Summary'
                },
                {
                    step: 2,
                    text: 'Confirm Your Details'
                },
            ]
        }
    },

    computed: {

        step(){
            return parseInt(this.$route.path.split('/').pop())
        },

    },
    methods: {

    },
    created(){
        if(this.step < 1 || !this.step || this.step == NaN) {
            this.$router.push('/donate/1')
        }
        this.metaTitle = ''
        this.metaDescription = ''
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/subscribe/subscribe.js